import { post } from "../../libs/ajax.js"

// 排单排期v2 阶段4 产能看板（纯只读·按角色脱敏：创意全量 view=full / 运营脱敏 view=ops）
export default {
    // 热力图：按天×大类组/叶组水位（创意全量返组级+数量；运营脱敏仅大类级+ratio/signal）
    getHeatmap: (data, options) => {
        return post("/work_order/capacity_board/heatmap", data, options)
    },
    // 渠道占比 vs 实际派单对比（创意全量含绝对量；运营脱敏只给百分比）
    getChannel: (data, options) => {
        return post("/work_order/capacity_board/channel", data, options)
    },
    // 筛选项：大类组下拉 + 默认时间窗
    getOptions: (data, options) => {
        return post("/work_order/capacity_board/options", data, options)
    },
}
